import Expandable from 'components/global/application/Expandable';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { BrandsInfoModel } from 'types/drupal/BrandInfo';

import './InventoryDropMenu.sass';

interface Props {
    // used to toggle display and switch content; component only displays with truthy values
    brands: BrandsInfoModel[];
    showing: boolean;
    // methods to update parent so it knows when its safe to clear hoveredItem
    mouseHovered(event: React.MouseEvent<any>): void;
    // ^-- same
    mouseUnHovered(event: React.MouseEvent<any>): void;
}

const InventoryDropMenu: React.StatelessComponent<Props> = (props: Props) => {
    return(
        <Expandable
            direction="vertical"
            maxHeight="34em"
            expanded={props.showing}
            onMouseEnter={props.mouseHovered}
            onMouseLeave={props.mouseUnHovered}
            id="submenu"
            className="InventoryDropMenu-container"
        >
            <div className="Padding-container">
                <div className="row">
                    <div className="col-lg-4">
                        {/*<span className="Category-header"><NavLink to="/new-arrivals">New Arrivals</NavLink></span>*/}
                        <span className="Category-header"><NavLink to="/inventory/category/acoustic-guitars">Acoustic Guitars</NavLink></span>
                        <span className="Menu-item"><NavLink to="/inventory/category/martin-flattops">Martin Flat-tops</NavLink></span>
                        <span className="Menu-item"><NavLink to="/inventory/category/gibson-and-epiphone-flattops">Gibson &amp; Epiphone Flat-tops</NavLink></span>
                        <span className="Menu-item"><NavLink to="/inventory/category/miscellaneous-flattops">Miscellaneous Flat-tops</NavLink></span>
                        <span className="Menu-item"><NavLink to="/inventory/category/archtop-acoustic-guitars">Arch-top Guitars</NavLink></span>
                        <span className="Menu-item"><NavLink to="/inventory/category/taylor-flat-tops">Taylor Flat-tops</NavLink></span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/classical-guitars">Classical Guitars</NavLink></span>
                        <hr />
                        <span className="Category-header" ><NavLink to="/brands">View Our Brands</NavLink></span>
                        {
                            props.brands.map((b: BrandsInfoModel, index: any) => {
                                return (
                                    // TODO - The link here needs to be an anchor tag because using NavLink effectively changes the
                                    // route and heading as expected, but does not reload the products of the route's brand
                                    // correctly though. It could be related to the Redux State not getting updated on route change
                                    <span key={`brand-link-${index}`} className="Menu-item"><a href={`/brands/${b.brand_name.value}/new`}>{b.brand_name.value}</a></span>
                                );
                            })
                        }
                        <hr />
                        <span className="Menu-item call-out" ><NavLink to="/new-arrivals">View New Arrivals</NavLink></span>
                        <span className="Menu-item call-out" ><NavLink to="/vintage-new-arrivals">View Vintage New Arrivals</NavLink></span>
                        <span className="Menu-item call-out" ><NavLink to="/inventory/vintage">View Vintage Only</NavLink></span>
                    </div>
                    <div className="col-border col-lg-4">
                        <span className="Category-header"><NavLink to="/inventory/category/electric-guitars">Electric Guitars</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/gibson-solidbody-electrics">Gibson Solidbody Electrics</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/miscellaneous-solidbody-electrics">Misc Solidbody Electrics</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/epiphone-electrics">Epiphone Electrics</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/fender-electrics">Fender Electrics</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/hollowbody-electrics">Hollowbody Electrics</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/electric-steel-guitars">Electric Steel Guitars</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/gretsch-electrics">Gretsch Electrics</NavLink></span>
                        <br />
                        <span className="Category-header" ><NavLink to="/inventory/category/mandolins-and-mandolin-family">Mandolins &amp; Mandolin Family</NavLink></span>
                    </div>
                    <div className="col-border col-lg-4">
                        <span className="Category-header"><NavLink to="/inventory/category/banjos">Banjos</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/five-string-banjos">Five-string Banjos</NavLink></span>
                        <span className="Menu-item"><NavLink exact to="/inventory/category/tenor-plectrum-and-other-banjo-family">Tenor, plectrum and other banjos</NavLink></span>
                        <br />
                        <span className="Category-header">Other</span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/resonator-guitars">Resonator Instruments</NavLink></span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/ukuleles-taropatches-and-tiples">Ukuleles, Taropatches, &amp; Tiples</NavLink></span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/tenor-and-plectrum-guitars">Tenor &amp; Plectrum Guitars</NavLink></span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/miscellaneous-instruments" id="Miscellaneous Instruments">Misc Instruments</NavLink></span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/basses">Basses</NavLink></span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/amplifiers">Amplifiers</NavLink></span>
                        <span className="Menu-item" ><NavLink to="/inventory/category/cases">Cases</NavLink></span>
                    </div>
                </div>
            </div>
        </Expandable>
    );
};

export default InventoryDropMenu;



// WEBPACK FOOTER //
// ./src/components/global/application/nav/InventoryDropMenu.tsx